import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyAg1qkkXl1pH1kuAZFxBuulvNgdYHxDMdc',
  authDomain: 'attackyouradventure-ee7a6.firebaseapp.com',
  databaseURL: 'https://attackyouradventure-ee7a6-default-rtdb.firebaseio.com',
  projectId: 'attackyouradventure-ee7a6',
  storageBucket: 'attackyouradventure-ee7a6.firebasestorage.app',
  messagingSenderId: '133917984912',
  appId: '1:133917984912:web:093c01569aa29af556f015',
  measurementId: 'G-L5CJXCFNZZ',
};

const app = initializeApp(firebaseConfig);

export default app;